module.exports = __webpack_public_path__ + "images/close@1x.png?692a6646";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close@1x.png
// module id = 609
// module chunks = 7